import $ from 'jquery';

$(document).ready(function() {
	$(document).on('click', '.js-warning-close', function() {
		$('.js-warning').hide();
	});
});


// WEBPACK FOOTER //
// ./src/js/general/warning.js